
























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ProjectModel } from "../models";
import dateFlip from "shared/filters/dateflip";
import TermList from "./TermList.vue";

@Component({
  components: { TermList },
  filters: {
    dateFlip,
  },
})
export default class SubscriptionsTable extends Vue {
  @Prop({ required: true })
  projects!: ProjectModel[];

  headers = [
    { text: this.t("id"), value: "id", sortable: false },
    { text: this.t("description"), value: "description", sortable: false },
    { text: this.t("startDate"), value: "start_date", sortable: false },
  ];

  pagination = {
    rowsPerPage: 5,
    descending: true,
  };

  rowsPerPageItems = [
    5,
    15,
    25,
    { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
  ];

  @Watch("projects")
  expandAllRows(): void {
    for (let i = 0; i < this.projects.length; i += 1) {
      const item = this.projects[i];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore It exists but the type doesn't include it
      const e = this.$refs.subscriptionsTable.expanded;
      this.$set(e, item.projectId, true);
    }
  }

  mounted(): void {
    this.expandAllRows();
  }

  private t(key: string): string {
    return this.$t("projects.table." + key).toString();
  }
}
